import { apiClient } from "../../../api/client";
import * as ActionType from "./dashboard.type";

export const getDashboard = () => async (dispatch) => {
  const res = await apiClient.get("dashboard/getDashboard");
  if (res.ok) {
    dispatch({ type: ActionType.GET_DASHBOARD, payload: res.data?.dashboard });
  } else {
    console.error(res.message);
  }
};

export const getTopSeller = () => async (dispatch) => {
  const res = await apiClient.get("dashboard/getTopSeller");
  if (res.ok) {
    dispatch({ type: ActionType.GET_TOP_SELLER, payload: res.data?.topSeller });
  } else {
    console.error(res.message);
  }
};

export const getTopProduct = () => async (dispatch) => {
  const res = await apiClient.get("dashboard/getTopProduct");
  if (res.ok) {
    dispatch({ type: ActionType.GET_TOP_PRODUCT, payload: res.data?.topProduct });
  } else {
    console.error(res.message);
  }
};

export const getTopUser = () => async (dispatch) => {
  const res = await apiClient.get("dashboard/getTopCustomer");
  if (res.ok) {
    dispatch({ type: ActionType.GET_TOP_USER, payload: res.data?.topCustomer });
  } else {
    console.error(res.message);
  }
};

export const getPopularProduct = () => async (dispatch) => {
  const res = await apiClient.get("dashboard/getPopularProduct");
  if (res.ok) {
    dispatch({
      type: ActionType.GET_POPULAR_PRODUCT,
      payload: res.data?.popularProduct,
    });
  } else {
    console.error(res.message);
  }
};

export const getRecenetOrder = () => async (dispatch) => {
  const res = await apiClient.get("dashboard/getRecentOrder");
  if (res.ok) {
    dispatch({
      type: ActionType.GET_RECENT_ORDER,
      payload: res.data?.recentOrders || res.data?.orders,
    });
  } else {
    console.error(res.message);
  }
};

export const getUser = (startDate, endDate) => async (dispatch) => {
  const res = await apiClient.get(
    `dashboard/getUser?startDate=${startDate}&endDate=${endDate}`
  );
  if (res.ok) {
    dispatch({ type: ActionType.GET_USER, payload: res.data?.users });
  } else {
    console.error(res.message);
  }
};

export const getOrder = (startDate, endDate) => async (dispatch) => {
  const res = await apiClient.get(
    `dashboard/getOrder?startDate=${startDate}&endDate=${endDate}`
  );
  if (res.ok) {
    dispatch({ type: ActionType.GET_ORDER, payload: res.data?.orders });
  } else {
    console.error(res.message);
  }
};

export const getUserChart = (startDate, endDate) => async (dispatch) => {
  const res = await apiClient.get(
    `dashboard/getUserChart?startDate=${startDate}&endDate=${endDate}`
  );
  if (res.ok) {
    dispatch({ type: ActionType.GET_USER_CHART, payload: res.data?.users });
  } else {
    console.error(res.message);
  }
};

export const getRevenueChart = (startDate, endDate) => async (dispatch) => {
  const res = await apiClient.get(
    `dashboard/getRevenueChart?startDate=${startDate}&endDate=${endDate}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.GET_REVENUE_CHART,
      payload: {
        total: res.data?.total,
        withCom: res.data?.withCom,
        withOut: res.data?.withOut,
      },
    });
  } else {
    console.error(res.message);
  }
};
